import { render, staticRenderFns } from "./OperaPriceConfigWindow.vue?vue&type=template&id=3aa142ac&scoped=true&"
import script from "./OperaPriceConfigWindow.vue?vue&type=script&lang=js&"
export * from "./OperaPriceConfigWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaPriceConfigWindow.vue?vue&type=style&index=0&id=3aa142ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa142ac",
  null
  
)

export default component.exports